<template>
    <div class="content" v-loading.fullscreen.lock="loading">
        <div class="content-c">
            <div class="title">提示:新项目使用当前项目配置</div>
            <el-form ref="form" label-width="130px" :model="form" :label-position="labelPosition">
                <el-form-item label="新项目的地区代码:" prop="code">
                    <el-input v-model="form.code" placeholder="如:test"></el-input>
                </el-form-item>
                <el-form-item label="新项目的地区名字:" prop="name">
                    <el-input v-model="form.name" placeholder="如:测试"></el-input>
                </el-form-item>
            </el-form>
            <el-button style="float:right;margin-top:20px" @click="setUp">创建</el-button>
        </div>
    </div>
</template>

<script>
    import { inherit } from '@/api/zone.js'
    export default {
        data() {
            return {
                form: {
                    fromId: '',
                    code: '',
                    name: ''
                },
                labelPosition: 'left',
                loading: false
            }
        },
        created() {
        },
        methods: {
            // 创建
            async setUp() {
                if (this.form.code == '' || this.form.name == '') {
                    this.$message.error('表单请填写完整!')
                } else {
                    this.loading = true
                    this.form.fromId = this.$cookies.get('zone')
                    try {
                        let inheritRes = await inherit(this.form)
                        if (inheritRes.status == 0) {
                            this.$message.success('创建成功!')
                            this.form = {}
                        }
                        this.loading = false
                    } catch (e) {
                        this.loading = false
                    }
                }
            },
        }
    }
</script>

<style scoped>
    .content {
        padding-top: 100px;
        margin: 0 auto;
    }

        .content .content-c {
            width: 500px;
        }

    .title {
        text-align: center;
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 40px;
    }
</style>